/**
 * Registreer telefoonklikken als offline conversie bij Google Ads.
 *
 * We onderscheppen de klik, sturen de POST, en laten de dialer pas openen
 * zodra de request klaar is (of na een korte fallback van 1s). Zonder
 * die vertraging wordt de request afgebroken wanneer de dialer opent. De
 * backend bepaalt (o.b.v. gclid) of er echt iets verstuurd wordt.
 */
const NAVIGATE_FALLBACK_MS = 1000;

export default function phoneTracking () {
    const callButtons = document.querySelectorAll('a[href^="tel:"]');
    if ( !callButtons.length ) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if ( !token ) return;

    callButtons.forEach(callButton => {
        callButton.addEventListener('click', event => {
            event.preventDefault();

            const url = callButton.href;
            let navigated = false;
            const navigate = () => {
                if ( navigated ) return;
                navigated = true;
                window.location.href = url;
            };

            fetch('/ajax/track-phone-click', {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                keepalive: true,
            }).catch(() => {}).finally(navigate);

            // Fallback: laat de klik nooit langer dan dit blijven hangen.
            setTimeout(navigate, NAVIGATE_FALLBACK_MS);
        });
    });
}
